import { SESSION_STATUS } from "@repo/database/session-status";

export const TERMINAL = new Set<string>([
  SESSION_STATUS.COMPLETED,
  SESSION_STATUS.FAILED,
  SESSION_STATUS.KILLED,
  SESSION_STATUS.ABSTAINED,
]);
